export default {
    meta: {
      label: 'Dutch'
    },
    data: {
      nl: {
        97: [['🍎', 'Apfel'], ['🦅', 'Adelaar']],
        98: [['🍌', 'Banaan'], ['👶', 'Baby'], ['🐝', 'Bij'], ['📫', 'Brievenbus']],
        99: [['🤡', 'Clown'], ['💻', 'Computer']],
        100: [['🐬', 'Dolfijn'], ['🚪', 'Deur']],
        101: [['🥚', 'Ei'], ['🦄','Eenhoorn']],
        102: [['🚲', 'Fiets']],
        103: [['👻','Geest'], ['🦍', 'Gorilla'], ['🎸', 'Gitaar']],
        104: [['🏑', 'Hockey'], ['🐹', 'Hamster']],
        105: [['🦑', 'Inktvis']],
        106: [['🤹🏼‍♀️', 'Jongleur'], ['👖', 'Jeans']],
        107: [['🧀', 'Kaas'],['🐈','Kat'],['🕯️','Kaars']],
        108: [['🦁', 'Leeuw'], ['🐆', 'Luipaard']],
        109: [['🌝', 'Maan'], ['👄', 'Mond'], ['🎶', 'Muziek']],
        110: [['👃', 'Neus']],
        111: [['🐙', 'Octopus'], ['👁️', 'Oog']],
        112: [['🥞', 'Pannekoeken'], ['🐸','Pad']],
        113: [['🥧','Quiche']],
        114: [['🤖', 'Robot'], ['♻️', 'Recycle'], ['🌧', 'Regen']],
        115: [['🐍', 'Slang'], ['🥗', 'Salade'], ['⭐️', 'Ster']],
        116: [['🌮', 'Taco'], ['🐅', 'Tijger']],
        117: [['🦉', 'Uil']],
        118: [['🏐', 'Volleyball'], ['🌋', 'Vulkaan'], ['🐦' ,'Vogel']],
        119: [['🌊', 'Water'], ['🍉', 'Watermeloen']],
        120: ['Xylofoon'],
        121: [['☯️', 'Yin'], ['☯️', 'Yang']],
        122: [['🦓', 'Zebra']]
      }
    }
  };
  
